import {
	MANDATE_TYPE_IFT,
	MANDATE_TYPE_BACS_CREDIT,
	MANDATE_TYPE_BACS_DEBIT,
	MANDATE_TYPE_DIRECT_DEBIT,
	MANDATE_TYPE_STANDING_ORDER,
	MANDATE_TYPE_SCHEDULE_TRANSFER,
	MANDATE_TYPE_SCHEDULE_PAYMENT,
	MANDATE_TYPE_CHAPS,
	capabilities,
} from '../../config';

const { CAPABILITY_TYPE_BACS, CAPABILITY_TYPE_FASTER_PAYMENTS, CAPABILITY_TYPE_IFT, CAPABILITY_TYPE_CHAPS } =
	capabilities;

export const mapPaymentTypeToCapability = (paymentType) => {
	switch (paymentType) {
		case MANDATE_TYPE_IFT:
			return CAPABILITY_TYPE_IFT;
		case MANDATE_TYPE_CHAPS:
			return CAPABILITY_TYPE_CHAPS;
		case MANDATE_TYPE_DIRECT_DEBIT:
		case MANDATE_TYPE_STANDING_ORDER:
		case MANDATE_TYPE_SCHEDULE_TRANSFER:
		case MANDATE_TYPE_SCHEDULE_PAYMENT:
			return CAPABILITY_TYPE_FASTER_PAYMENTS;
		case MANDATE_TYPE_BACS_CREDIT:
		case MANDATE_TYPE_BACS_DEBIT:
			return CAPABILITY_TYPE_BACS;
		default:
			return undefined;
	}
};
